// extracted by mini-css-extract-plugin
export var barContainer = "_2h-0";
export var extraThin = "_2h-3";
export var fillBar = "_2h-6";
export var fillContainer = "_2h-4";
export var overflow = "_2h-8";
export var overflowContainer = "_2h-5";
export var regular = "_2h-7";
export var thick = "_2h-1";
export var thin = "_2h-2";